import { get } from "lodash";
import PutCompanyWorkflowProxy from "../proxies/back-end/workflow/put-company-workflow";
import ChangeAddressStartProxy from "../proxies/back-end/workflow/change-address/change-address-start";
import ChangeOfDirectorProxy from "../proxies/back-end/workflow/change-of-director/change-of-director-proxy";
import AppointmentOfNomineeDirectorProxy from "../proxies/back-end/workflow/appointment-of-director/appointment-of-nominee-director-proxy";
import PendingAppointmentOfNomineeDirectorProxy from "../proxies/back-end/workflow/appointment-of-director/pending-appointment-of-nominee-director-proxy ";
import PendingChangeOfDirectorProxy from "../proxies/back-end/workflow/change-of-director/pending-change-of-director-proxy";
import AmendCompanyShareStructureProxy from "../proxies/back-end/workflow/amend-company-share-structure/amend-company-share-structure-proxy";
import PendingAmendCompanyShareStructureProxy from "../proxies/back-end/workflow/amend-company-share-structure/pending-amend-company-share-structure-proxy ";
import InsertCompanyUserProxy from "@/proxies/back-end/company-user/insert";
import UpdateCompanyUserProxy from "@/proxies/back-end/company-user/update";
import InviteUserProxy from "@/proxies/back-end/company-user/invite";
import { Constants } from "customer-sdk/constants";

const WORKFLOW_CONSTANTS = Constants.WORK_FLOW.WORKFLOW_CONSTANTS;
const CAMUNDA_WORKFLOW_CONSTANTS = Constants.WORK_FLOW.CAMUNDA_WORKFLOW_CONSTANTS;
const PAGE_URLS = Constants.PAGE_URLS;
const SHAREHOLDER_TYPES = Constants.SHAREHOLDER_TYPES;

// eslint-disable-next-line complexity
export async function handleTask(task, paymentData, paymentStatus, companyUsers, shouldNavigate = true) {
  localStorage.removeItem("wf_ms_process_id");
  if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.CHANGE_OF_ADDRESS) {
    await handleChangeAddress(task, paymentData, paymentStatus, shouldNavigate);
  } else if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.APPOINTMENT_OF_DIRECTOR && !task.payload.camunda) {
    handleAppointmentOfDirector(task, paymentData, paymentStatus, shouldNavigate);
  } else if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.CHANGE_OF_DIRECTOR && !task.payload.camunda) {
    handleChangeOfDirector(task, paymentData, paymentStatus, shouldNavigate);
  } else if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.APPOINTMENT_OF_DIRECTOR && task.payload.camunda) {
    await handleAppointmentOfDirectorForCamundaRequest(task, paymentData, paymentStatus, shouldNavigate);
  } else if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.CHANGE_OF_DIRECTOR && task.payload.camunda) {
    await handleChangeOfDirectorCamundaRequest(task, paymentData, paymentStatus, shouldNavigate);
  } else if (task.type === WORKFLOW_CONSTANTS.FLOW_TYPE.AMEND_COMPANY_SHARE_STRUCTURE) {
    await handleAmendCompanyShareStructureCamundaRequest(
      task,
      paymentData,
      paymentStatus,
      companyUsers,
      shouldNavigate
    );
  }
}

let handleChangeAddress = async (task, paymentData, paymentStatus, shouldNavigate) => {
  console.log("payload::", task.payload);
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price =
      paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID
        ? paymentData.amount
        : paymentData.invoice
        ? paymentData.invoice.totalAmount
        : paymentData.externalInvoice.AmountDue;
    if (paymentData.actionItems) {
      task.payload.payload.price = paymentData.actionItems[0].price;
    }
    const result = await ChangeAddressStartProxy.postChangeAddressStart(task.payload);
    console.log("this result::", result);
    if (paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID) {
      await handleSavePaidCompanyWorkFlow(task, paymentData, result);
    } else {
      await handleSavePendingPaymentCommpanyWorkflow(task, paymentData, result, shouldNavigate);
    }
  } catch (error) {
    console.error("something went wrong::", error);
    throw error;
  }
};

let handleAppointmentOfDirector = async (task, paymentData, paymentStatus, shouldNavigate) => {
  console.log("payload::", task.payload);
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price =
      paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID
        ? paymentData.amount
        : paymentData.invoice
        ? paymentData.invoice.totalAmount
        : paymentData.externalInvoice.AmountDue;
    if (paymentData.actionItems) {
      task.payload.payload.price = paymentData.actionItems[0].price;
    }
    console.log("this payload::", JSON.stringify(task));
    const result = await AppointmentOfNomineeDirectorProxy.appointmentOfDirectorStart(task.payload);
    console.log("this result::", result);
    if (paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID) {
      await handleSavePaidCompanyWorkFlow(task, paymentData, result);
    } else {
      await handleSavePendingPaymentCommpanyWorkflow(task, paymentData, result, shouldNavigate);
    }
  } catch (error) {
    console.error("something went wrong::", error);
    throw error;
  }
};

let handleAmendCompanyShareStructureCamundaRequest = async (
  task,
  paymentData,
  paymentStatus,
  companyUsers,
  shouldNavigate
) => {
  console.log("handleAmendCompanyShareStructureCamundaRequest::", task.payload, "paymentData", paymentData);
  console.log("handleAmendCompanyShareStructureCamundaRequest:: task", task);
  console.log("handleAmendCompanyShareStructureCamundaRequest:: companyUsers", companyUsers);
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price = paymentData.amount
      ? paymentData.amount
      : paymentData.invoice
      ? paymentData.invoice.amount
      : paymentData.externalInvoice.AmountDue;
    await createNewAndInviteShareholder(task, companyUsers);
    // if (task.microservice_enabled) {
    // const { PAID } = WORKFLOW_CONSTANTS.PAYMENT_STATUS;
    // if (paymentStatus == PAID) {
    //   await handleUpgradeAmendCompanyShareStructureCamundaRequest(task, paymentData);
    // } else {
    //   await handleSavePendingWFForAmendCompanyShareStructureCamunda(task, paymentData);
    // }
    // } else {
    await handleUpgradeAmendCompanyShareStructureCamundaRequest(task, paymentData, paymentStatus, shouldNavigate);
    // }

    localStorage.removeItem(`amendCompanyShareStructureData_${get(task, "payload.payload.company_id")}`);
  } catch (error) {
    throw error;
  }
};

// eslint-disable-next-line complexity
const handleUpgradeAmendCompanyShareStructureCamundaRequest = async (
  task,
  paymentData,
  paymentStatus,
  shouldNavigate
) => {
  const { PAID } = WORKFLOW_CONSTANTS.PAYMENT_STATUS;
  task.payload.payload.data = {
    price: paymentData.amount
      ? paymentData.amount
      : paymentData.invoice
      ? paymentData.invoice.amount
      : paymentData.externalInvoice.AmountDue,
    invoice_url: paymentData.invoice ? paymentData.invoice.url : paymentData.invoiceUrl,
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoice
      ? paymentData.invoice.number
      : paymentData.invoiceNumber
      ? paymentData.invoiceNumber
      : paymentData.externalInvoice.InvoiceNumber,
    payment_type: task.payload.payload.payment_status === PAID ? "STRIPE" : "MANUAL",
    transaction_id: paymentData.transaction_id,
    xero_contact_id: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.ContactID : null,
    xero_contact_email: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.Name : null,
    payment_status: task.payload.payload["payment_status"],
  };

  const result = await AmendCompanyShareStructureProxy.start(task.payload);
  if (shouldNavigate) {
    window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${get(
      result,
      CAMUNDA_WORKFLOW_CONSTANTS.CAMUNDA_KEY_VARIABLES.BUSINESS_KEY
    )}`;
  } else {
    localStorage.setItem(
      "wf_ms_process_id",
      get(result, CAMUNDA_WORKFLOW_CONSTANTS.CAMUNDA_KEY_VARIABLES.BUSINESS_KEY)
    );
  }
};

const handleSavePendingWFForAmendCompanyShareStructureCamunda = async (task, paymentData) => {
  task.payload.payload = Object.assign(task.payload.payload, {
    transaction_id: paymentData.transaction_id,
    payment_type: "MANUAL",
    invoice_url: paymentData.invoice ? paymentData.invoice.url : paymentData.invoiceUrl,
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoice ? paymentData.invoice.number : paymentData.externalInvoice.InvoiceNumber,
    price: paymentData.invoice ? paymentData.invoice.totalAmount : paymentData.externalInvoice.AmountDue,
  });
  console.log("handleSavePendingWFForAmendCompanyShareStructureCamunda task.payload ::::::", task.payload);
  const response = await PendingAmendCompanyShareStructureProxy.execute(task.payload);

  window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${response._id}&isPending=true`;
};
const handleAppointmentOfNomineeDirector = async (task, paymentData) => {
  task.payload.payload.data = {
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoiceNumber ? paymentData.invoiceNumber : paymentData.externalInvoice.InvoiceNumber,
    invoice_url: paymentData.invoiceUrl,
    type: task.type,
    payment_type: "STRIPE",
    transaction_id: paymentData.transaction_id,
    xero_contact_id: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.ContactID : null,
    xero_contact_email: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.Name : null,
    price: paymentData.amount,
    subscription_id: task.payload.payload.subscription_id,
    payment_status: WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID,
  };
  console.log("handleAppointmentOfNomineeDirector task.payload ::::::", task.payload);
  const result = await AppointmentOfNomineeDirectorProxy.appointmentOfDirectorStart(task.payload);
  window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${get(
    result,
    CAMUNDA_WORKFLOW_CONSTANTS.CAMUNDA_KEY_VARIABLES.BUSINESS_KEY
  )}`;
};

const handleSavePendingWFForAppointmentOfNDCamunda = async (task, paymentData, shouldNavigate) => {
  task.payload.payload = Object.assign(task.payload.payload, {
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoice ? paymentData.invoice.number : paymentData.externalInvoice.InvoiceNumber,
    invoice_url: paymentData.invoice ? paymentData.invoice.url : paymentData.invoiceUrl,
    type: task.type,
    payment_type: "MANUAL",
    price: paymentData.invoice ? paymentData.invoice.totalAmount : paymentData.externalInvoice.AmountDue,
    subscription_id: task.payload.payload.subscription_id,
  });

  console.log("handleSavePendingWFForAppointmentOfNDCamunda task.payload ::::::", task.payload);
  const response = await PendingAppointmentOfNomineeDirectorProxy.createPendingRequestForAppointmentOfNDProxy(
    task.payload
  );

  if (shouldNavigate) {
    window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${response._id}&isPending=true`;
  } else {
    localStorage.setItem("wf_ms_process_id", response._id);
  }
};

let handleAppointmentOfDirectorForCamundaRequest = async (task, paymentData, paymentStatus, shouldNavigate) => {
  const { PAID } = WORKFLOW_CONSTANTS.PAYMENT_STATUS;
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price =
      paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID
        ? paymentData.amount
        : paymentData.invoice
        ? paymentData.invoice.totalAmount
        : paymentData.externalInvoice.AmountDue;
    if (
      paymentStatus == PAID &&
      get(task, "payload.payload.directors", []).length > 0 &&
      get(task, "payload.payload.subscription_id")
    ) {
      window.location.href = `${PAGE_URLS.POST_REQUEST}?isSubscriptionExtended=true&price=${task.payload.payload.price}`;
    } else if (paymentStatus == PAID) {
      await handleAppointmentOfNomineeDirector(task, paymentData);
    } else {
      await handleSavePendingWFForAppointmentOfNDCamunda(task, paymentData, shouldNavigate);
      return;
    }
  } catch (error) {
    throw error;
  }
};

const handleChangeOfDirectorWithNDCamundaRequest = async (task, paymentData) => {
  task.payload.payload.data = {
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoiceNumber ? paymentData.invoiceNumber : paymentData.externalInvoice.InvoiceNumber,
    invoice_url: paymentData.invoiceUrl,
    type: task.type,
    payment_type: "STRIPE",
    transaction_id: paymentData.transaction_id,
    xero_contact_id: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.ContactID : null,
    xero_contact_email: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.Name : null,
    price: paymentData.amount ? paymentData.amount : paymentData.actionItems[0].price,
    subscription_id: task.payload.payload.subscription_id,
    payment_status: WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID,
  };
  console.log("handleChangeOfDirectorWithNDCamundaRequest task.payload ::::::", task.payload);
  // create api for change-of-director/start
  const result = await ChangeOfDirectorProxy.changeOfDirectorStart(task.payload);
  window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${get(
    result,
    CAMUNDA_WORKFLOW_CONSTANTS.CAMUNDA_KEY_VARIABLES.BUSINESS_KEY
  )}`;
};

const handleSavePendingWFForChangeOfDirectorCamunda = async (task, paymentData, shouldNavigate) => {
  task.payload.payload = Object.assign(task.payload.payload, {
    invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
    invoice_number: paymentData.invoice ? paymentData.invoice.number : paymentData.externalInvoice.InvoiceNumber,
    invoice_url: paymentData.invoice ? paymentData.invoice.url : paymentData.invoiceUrl,
    type: task.type,
    payment_type: "MANUAL",
    price: paymentData.invoice ? paymentData.invoice.totalAmount : paymentData.externalInvoice.AmountDue,
    subscription_id: task.payload.payload.subscription_id,
  });

  console.log("handleSavePendingWFForChangeOfDirectorCamunda task.payload ::::::", task.payload);
  // create endpoint for saving pending change of Director
  const response = await PendingChangeOfDirectorProxy.createPendingRequestForChangeOfDirectorProxy(task.payload);
  if (shouldNavigate) {
    window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${response._id}&isPending=true`;
  } else {
    localStorage.setItem("wf_ms_process_id", response._id);
  }
};

let handleChangeOfDirectorCamundaRequest = async (task, paymentData, paymentStatus, shouldNavigate) => {
  const { PAID } = WORKFLOW_CONSTANTS.PAYMENT_STATUS;
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price =
      paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID
        ? paymentData.amount
        : paymentData.invoice
        ? paymentData.invoice.totalAmount
        : paymentData.externalInvoice.AmountDue;

    if (paymentStatus == PAID) {
      await handleChangeOfDirectorWithNDCamundaRequest(task, paymentData);
    } else {
      await handleSavePendingWFForChangeOfDirectorCamunda(task, paymentData, shouldNavigate);
    }
  } catch (error) {
    throw error;
  }
};

let handleChangeOfDirector = async (task, paymentData, paymentStatus, shouldNavigate) => {
  console.log("payload::", task.payload);
  try {
    task.payload.payload["payment_status"] = paymentStatus;
    task.payload.payload.price =
      paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID
        ? paymentData.amount
        : paymentData.invoice
        ? paymentData.invoice.totalAmount
        : paymentData.externalInvoice.AmountDue;
    console.log("this payload::", JSON.stringify(task));
    const result = await ChangeOfDirectorProxy.changeOfDirectorStart(task.payload);
    console.log("this result::", result);
    if (paymentStatus == WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID) {
      await handleSavePaidCompanyWorkFlow(task, paymentData, result);
    } else {
      await handleSavePendingPaymentCommpanyWorkflow(task, paymentData, result, shouldNavigate);
    }
  } catch (error) {
    console.error("something went wrong::", error);
    throw error;
  }
};

let handleSavePaidCompanyWorkFlow = async (task, paymentData, wfeResult) => {
  try {
    console.log("this result::", wfeResult);
    console.log("this payload::", task.payload);
    console.log("this payment data::", paymentData);
    const payload = {
      authToken: task.payload.authToken,
      companyId: task.payload.payload.company_id,
      processId: wfeResult.process.id,
      data: {
        invoice_id: paymentData.invoiceId ? paymentData.invoiceId : paymentData.externalInvoice.InvoiceID,
        invoice_number: paymentData.invoiceNumber
          ? paymentData.invoiceNumber
          : paymentData.externalInvoice.InvoiceNumber,
        invoice_url: paymentData.invoiceUrl,
        type: task.type,
        payment_type: "STRIPE",
        transaction_id: paymentData.transaction_id,
        xero_contact_id: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.ContactID : null,
        xero_contact_email: paymentData.externalInvoice ? paymentData.externalInvoice.Contact.Name : null,
        price: paymentData.amount,
        subscription_id: task.payload.payload.subscription_id,
        payment_status: WORKFLOW_CONSTANTS.PAYMENT_STATUS.PAID,
      },
    };
    // debugger;
    await PutCompanyWorkflowProxy.putCompanyWorkflow(payload);
    window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${wfeResult.process.id}`;
  } catch (error) {
    console.error("something went wrong::", error);
  }
};

let handleSavePendingPaymentCommpanyWorkflow = async (task, paymentData, wfeResult, shouldNavigate) => {
  console.log("payload::", task.payload);
  try {
    const payload = {
      authToken: task.payload.authToken,
      companyId: task.payload.payload.company_id,
      processId: wfeResult.process.id,
      data: {
        invoice_id: paymentData.invoice ? paymentData.invoice._id : paymentData.externalInvoice.InvoiceID,
        invoice_number: paymentData.invoice ? paymentData.invoice.number : paymentData.externalInvoice.InvoiceNumber,
        invoice_url: paymentData.invoice ? paymentData.invoice.url : paymentData.invoiceUrl,
        type: task.type,
        payment_type: "MANUAL",
        price: paymentData.invoice ? paymentData.invoice.totalAmount : paymentData.externalInvoice.AmountDue,
        subscription_id: task.payload.payload.subscription_id,
      },
    };
    // debugger;
    await PutCompanyWorkflowProxy.putCompanyWorkflow(payload);
    if (shouldNavigate) {
      window.location.href = `${PAGE_URLS.POST_REQUEST}?processId=${wfeResult.process.id}`;
    } else {
      localStorage.setItem("wf_ms_process_id", wfeResult.process.id);
    }
  } catch (error) {
    console.error("something went wrong::", error);
  }
};

const buildContactInput = (newShareholder, existingUser, payload) => {
  let shareholder;

  if (newShareholder.type === SHAREHOLDER_TYPES.INDIVIDUAL) {
    shareholder = {};
  } else if (newShareholder.type === SHAREHOLDER_TYPES.CORPORATE) {
    shareholder = {
      corporate: {
        name: newShareholder.corporate_details.corporate_name,
      },
    };
  }
  return {
    authToken: payload.authToken,
    companyId: payload.payload.company_id,
    user: {
      firstName: newShareholder.first_name,
      lastName: newShareholder.last_name,
      email: newShareholder.email,
    },
    director: get(existingUser, "director", null),
    shareholder,
    isPointOfContact: get(existingUser, "is_main_point_of_contact", false),
  };
};

const sendInvitation = async (companyUserId, authToken) => {
  let proxy = new InviteUserProxy();
  await proxy.execute({ authToken, id: companyUserId });
};

const createNewAndInviteShareholder = async (task, companyUsers) => {
  const insertProxy = new InsertCompanyUserProxy();
  let updateProxy = new UpdateCompanyUserProxy();

  const shareholders = get(task, "payload.payload.customerAppPayload.shareholders", []);
  const otherCompanyUsers = companyUsers.filter((cUser) => !cUser.shareholder);

  const updatedShareholders = await Promise.all(
    shareholders.map(async (cUser) => {
      if (cUser.is_existing) return cUser;

      const existingUser = otherCompanyUsers.find((otherCUser) => otherCUser.user.email === cUser.email);
      let companyUser = buildContactInput(cUser, existingUser, task.payload);
      let response;
      if (existingUser) {
        response = await updateProxy.execute({ ...companyUser, isFromRequest: true, companyUserId: existingUser._id });
        cUser.id = response._id;
      } else {
        response = await insertProxy.execute(companyUser);
        cUser.id = response.companyUser._id;
      }
      await sendInvitation(cUser.id, task.payload.authToken);
      return cUser;
    })
  );

  task.payload.payload.customerAppPayload.shareholders = updatedShareholders;
};
